import migrateCollections from "./migrate-collections.js";

export default {
	migrateCollections,
};
